import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { BehfaRole_Interface, Empty_BehfaRole_Interface } from 'src/app/Interface/BehfaRole_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { BehfaRoleService } from 'src/app/Service/BehfaRole/BehfaRole.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-BehfaRoleEdit',
  templateUrl: './BehfaRoleEdit.component.html',
  styleUrls: ['./BehfaRoleEdit.component.scss']
})
export class BehfaRoleEditComponent implements OnInit {

  Title:string=""
  EditRecord:number
  public Editor = ClassicEditor;
  public model = {
    editorData: '<p>متن خود را اینجا تایپ کنید ...</p>'
  };
  public config = {
    language: 'fa'
  };

  constructor(
    private Alertify_Service:AlertifyService,
    private BehfaRole_Service:BehfaRoleService,
    private Nav_Service:NavService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))

    this.Nav_Service.CheckValidPage(1105).subscribe(
      data=>{

        this.BehfaRole_Service.GetSingle(this.EditRecord).subscribe(
          data=>{
            this.Title = data.title
            this.model.editorData=data.dsc
          },error=>{
            // AuthInterceptor owns authentication; feature errors must preserve credentials.
          }
        )

      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }


  InProccessing:boolean=false
  onSubmitForm(){

    if(!this.Title)
    {
      this.Alertify_Service.ErrorMessage("عنوان را وارد نمائید")
    }
    else{
      var Record:BehfaRole_Interface=Empty_BehfaRole_Interface()
      Record.title=this.Title
      Record.dsc=this.model.editorData
      Record.id=this.EditRecord

      this.InProccessing=true
      this.BehfaRole_Service.EditBehfaRole(Record).subscribe(
        data=>{
          this.Alertify_Service.SuccessMessage("اطلاعات در سامانه ثبت شد")
          this.InProccessing=false
        },error=>{
          // AuthInterceptor owns authentication; feature errors must preserve credentials.
        }
      )

    }

  }

}
